import React from "react";
import { Stack } from "react-bootstrap";

const DataRegisterDropDown = ({ idAptos, idCL, idMF }) => {
  return (
    <Stack className="ps-2" gap={0}>
      {idAptos && (
        <h5 className="text-secondary fs-6 text-small">APTOS:{idAptos}</h5>
      )}
      {idCL && <h5 className="text-secondary fs-6 text-small">CL:{idCL}</h5>}
      {idMF && <h5 className="text-secondary fs-6 text-small">MF:{idMF}</h5>}
    </Stack>
  );
};

export default DataRegisterDropDown;
